import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { MotivoPerdaVendaOportunidade } from '../motivo-perda-venda-oportunidade';

@Component({
    selector: 'sgt-motivo-perda-venda-oportunidade-form',
    templateUrl: './motivo-perda-venda-oportunidade-form.component.html',
    styleUrls: ['./motivo-perda-venda-oportunidade-form.component.less']
})
export class MotivoPerdaVendaOportunidadeFormComponent {
    @Input() entity: MotivoPerdaVendaOportunidade;
    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    isValid() {
        if (this.form.invalid) {
            this.messageService.warning('Selecione corretamente todas as opções da gestão de oportunidade deste motivo', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
